import PropTypes from 'prop-types';
export var type = PropTypes.shape({
  LastTradedPx: PropTypes.number.isRequired,
  Rolling24HrPxChange: PropTypes.number.isRequired,
  BestBid: PropTypes.number.isRequired,
  BestOffer: PropTypes.number.isRequired,
  Rolling24HrVolume: PropTypes.number.isRequired,
  SessionLow: PropTypes.number.isRequired,
  SessionHigh: PropTypes.number.isRequired
});
export var defaultProps = {
  LastTradedPx: 0,
  Rolling24HrPxChange: 0,
  BestBid: 0,
  BestOffer: 0,
  Rolling24HrVolume: 0,
  SessionLow: 0,
  SessionHigh: 0
};